import { inject, Injectable, signal } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { openCiSnackbar } from '@iurban-malaga/cicerone-ui';
import { TranslateService } from '@ngx-translate/core';
import { MatBottomSheetService, RestService } from 'src/app/services';
import { PayloadSendIncidentsSurvey, StructureField } from '../interfaces';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class IncidentsReporterSurveyForm {
  // Service injections
  private _translateService = inject(TranslateService); // TODO: EN SSR SELECTED LANGUAGE SERVICE
  private _restService = inject(RestService); // TODO: ESTO CAMBIARA EN SSR
  private _matBottomSheetService = inject(MatBottomSheetService);
  
  // State signals
  private _markAllFormFieldsAsTouched = signal<boolean>(false);
  
  // Getters
  public markAllFormFieldsAsTouched = this._markAllFormFieldsAsTouched.asReadonly();
  
  // Setters
  public setMarkAllFormFieldsAsTouched(markAsTouched: boolean): void {
    this._markAllFormFieldsAsTouched.set(markAsTouched);
  }

  // Methods
  public submitForm(formGroup: FormGroup, surveyId: number, fieldList: StructureField[] ): void {    
    const payload = this.buildPayload(formGroup, surveyId, fieldList);
        
    this._restService.saveSurvey(payload)
      .subscribe({
        next: (_response) => {
          this.toggleBottomSheet();
          this.openSuccessSendIncidentsSurveySnackbar();
        },
        error: (error: HttpErrorResponse) => {
          console.error('Error submitting survey:', error);
        
          this.openErrorSendIncidentsSurveySnackbar();  
        }
      });
  }

  buildPayload(formGroup: FormGroup, 
               surveyId: number, 
               fieldList: StructureField[]
              ): PayloadSendIncidentsSurvey | undefined 
  {
    if (!formGroup) return;

    const data = fieldList.map((field, index) => {
      const formControlName = `${field.type}_${index}`;
      return {
        question: field.title ?? '',
        type: field.type,
        answer: formGroup.get(formControlName)?.value
      };
    });
    
    return {
      survey_id: surveyId.toString(),
      data: data
    }
  }
  
  public markFieldAsTouched(control: AbstractControl | null): void {
    control?.markAsTouched();
    control?.markAsDirty();
  }

  public isInvalidField(control: AbstractControl | null): boolean {
    return !!control && control.invalid && (control.touched || control.dirty);
  }
  
  public openSuccessSendIncidentsSurveySnackbar() {
    openCiSnackbar({
      content: this._translateService.instant('Encuesta enviada con éxito'),
      status: 'success',
      'icon-name': 'btn-check',
      'horizontal-position': 'end',
      'vertical-position': 'bottom',
      duration: 4000
    })
  } 
  
  public openReviewIncidentsSurveySnackbar() {
    openCiSnackbar({
      content: this._translateService.instant('No se ha enviado la encuesta. Por favor, revise los campos'),
      status: 'error',
      'icon-name': 'alert',
      'horizontal-position': 'end',
      'vertical-position': 'bottom',
      duration: 4000
    })
  } 
    
  public openErrorSendIncidentsSurveySnackbar() {
    openCiSnackbar({
      content: this._translateService.instant('Error al enviar la encuesta'),
      status: 'error',
      'icon-name': 'alert',
      'horizontal-position': 'end',
      'vertical-position': 'bottom',
      duration: 4000
    })
  } 
  
  toggleBottomSheet() {
    this._matBottomSheetService.closeAllMatBottomSheets();
  }
}
